// extracted by mini-css-extract-plugin
module.exports = {"chart":"DefaultChart_chart__1KOQA","funnel":"DefaultChart_funnel__3aAUw"};